import React from 'react';
import { Menu } from 'antd';
import { localization } from '../../Utils/Localization/localization';
import { connect } from 'react-redux';
import { languageSelector } from '../../Redux/Reducers/settingsReducer';
import { loginedSelector } from '../../Redux/Reducers/authReducer';
import { useHistory } from 'react-router-dom';

interface StateProps {
  language: string,
  logined: boolean
}
interface Props extends StateProps { }

function MenuLayout(props: Props) {
  const history = useHistory();
  return (
    <>
      {
        props.logined
          ? <Menu
            style={{ width: window.screen.width <= 600 ? '25%' : '15%' }}
            mode={'inline'}
          >
            <Menu.Item key='reports' onClick={() => history.push('/reports')}>
              {localization('reports', props.language)}
            </Menu.Item>
            <Menu.Item key='orders' onClick={() => history.push('/orders')}>
              {localization('orders', props.language)}
            </Menu.Item>
            <Menu.Item key='categories' onClick={() => history.push('/categories')}>
              {localization('categories', props.language)}
            </Menu.Item>
            <Menu.SubMenu
              key='products'
              title={
                <span>{localization('products', props.language)}</span>
              }
            >
              <Menu.Item key='allProducts' onClick={() => history.push('/products')}>
                {localization('allProducts', props.language)}
              </Menu.Item>
              <Menu.Item key='addProducts' onClick={() => history.push('/addproduct')}>
                {localization('addProducts', props.language)}
              </Menu.Item>
            </Menu.SubMenu>

          </Menu>
          : <Menu
            style={{ width: '15%' }}
            defaultSelectedKeys={['auth']}
            mode={'inline'}
          >
            <Menu.Item key='auth'>
              {localization('auth', props.language)}
            </Menu.Item>
          </Menu>
      }

    </>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    logined: loginedSelector(state)
  }
}

const ConnectedMenu = connect(mapStateToProps)(MenuLayout);

export { ConnectedMenu as MenuLayout };